export default {
    GOOGLE_API: 'AIzaSyA1nrnDg_J6_F4ke1Y45msIHQD5CPNSqS8' //'AIzaSyCHUCmpR7cT_yDFHC98CZJy2LTms-IwDlM'
};